@use "assets/styles/abstracts/variables" as v;
@use "assets/styles/abstracts/mixins/typography" as t;

.select {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.label {
  color: v.$palette-white;
  @include t.text(10px, 12px, "bold");
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.header {
  position: relative;
  width: 100%;
}

.headerField {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 48px;
  padding: 13px 16px;
  border: 1px solid v.$palette-signal-live;
  border-radius: 6px;
  background: v.$palette-signal-bg;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s ease;

  &:hover:not(:disabled) {
    border-color: v.$palette-green-500;
  }
}

.headerFieldFilled {
  border-color: v.$palette-signal-idle;
}

.headerFieldOpen {
  border-color: v.$palette-green-500;
}

.headerFieldError {
  border-color: v.$error-color;
}

.headerFieldDisabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.headerIcon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;

  // img {
  //   width: 22px;
  //   height: 22px;
  // }
}

.headerText {
  max-width: 90%;
  flex: 1;
  min-width: 0;
  color: v.$palette-white;
  @include t.text(14px, 22px, "normal");
}

.headerTextEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: auto;
}

.headerTextPlaceholder {
  color: v.$palette-signal-structure;
}

.chevron {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  color: v.$palette-white;
  transform: rotate(0deg);
  transition: transform 0.2s ease;
  pointer-events: none;
  position: absolute;
  right: 16px;
}

.chevronOpen {
  transform: rotate(180deg);
}

.chevronDisabled {
  opacity: 0.4;
}

.errorMessage {
  display: block;
  margin-top: 4px;
  color: v.$error-color;
  @include t.text(12px, 18px, "normal");
  position: absolute;
}

.body {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  background: v.$palette-signal-bg;
  border: 1px solid v.$palette-signal-live;
  border-radius: 6px;
  padding: 4px 8px;
  z-index: 100;
  box-shadow: 0 4px 7.5px rgba(58, 112, 191, 0.1);
}

.item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px 8px 8px;
  border-radius: 6px;
  cursor: pointer;
  color: v.$palette-white;
  @include t.text(14px, 22px, "normal");
  transition: background 0.15s ease;

  &:hover {
    background: v.$palette-signal-live;
  }
}

.itemCheckbox {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 2px;
  border: 1px solid v.$green-dark-color;
  border-radius: 4px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.02) 100%);
}

.itemCheckboxChecked {
  border-color: v.$palette-checkbox-active;
  background: v.$palette-checkbox-active;
  box-shadow:
    -2px -2px 0 0 v.$palette-checkbox-shadow,
    -2px 2px 0 0 v.$palette-checkbox-shadow,
    2px -2px 0 0 v.$palette-checkbox-shadow,
    2px 2px 0 0 v.$palette-checkbox-shadow;
}

.itemCheckboxIcon {
  width: 12px;
  height: 12px;
  color: v.$palette-white;
}

.itemChecked {
  background: transparent;

  &:hover {
    background: v.$palette-signal-live;
  }
}

.subtitle {
  padding: 8px 12px;
  color: v.$palette-gray-500;
  @include t.text(11px, 16px, "semi-bold");
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.checkbox {
  flex-shrink: 0;
}

.outerBorder {
  &:focus-within {
    border: 2px solid transparent;
  }
}
